import { useEffect, useState } from 'react';
import { Box, Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useDataProvider, useNotify } from 'react-admin';
import { TPADataType, TpaSourceFilterProps } from '../../utils/DataTypes';

const TpaSourceFilter = ({
  selectedTpa,
  setSelectedTpa,
  label = 'Copy Settings From TPA',
  disabled = false,
  refreshKey,
}: TpaSourceFilterProps) => {
  const [tpaList, setTpaList] = useState<TPADataType[]>([]);
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const notify = useNotify();

  useEffect(() => {
    setLoading(true);
    dataProvider
      .getList('TPAsWithSummaryConfigs', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'vendor_name', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setTpaList(data);
        setLoading(false);
      })
      .catch((error) => {
        notify('Error: Could not fetch TPA list with configs', { type: 'error' });
        setLoading(false);
      });
  }, [dataProvider, notify, refreshKey]);

  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        options={tpaList}
        getOptionLabel={(option) => option.vendor_name || ''}
        isOptionEqualToValue={(option, value) => option.vendor_number === value.vendor_number}
        value={selectedTpa}
        onChange={(event, newValue) => setSelectedTpa(newValue)}
        loading={loading}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default TpaSourceFilter;
